import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';

interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    content: React.ReactNode;
    confirmButtonText?: string;
    cancelButtonText?: string;
    loading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    open,
    title,
    content,
    confirmButtonText = 'Delete',
    cancelButtonText = 'Cancel',
    loading = false,
    onConfirm,
    onCancel,
}) => {
    return (
        <Dialog 
            open={open} 
            onClose={onCancel}
            PaperProps={{
                sx: { 
                    bgcolor: '#111', 
                    color: '#FFF', 
                    borderRadius: '12px', 
                    border: '1px solid #222',
                    minWidth: 400
                }
            }}
        >
            <DialogTitle sx={{ fontSize: '1.25rem', fontWeight: 800, p: 3, pb: 1 }}>{title}</DialogTitle>
            <DialogContent sx={{ p: 3, pt: 1 }}>
                <DialogContentText component="div" sx={{ color: '#666', fontSize: '0.95rem', lineHeight: 1.6 }}>
                    {content}
                </DialogContentText>

            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 1, gap: 1.5 }}>
                <Button 
                    onClick={onCancel} 
                    sx={{ color: '#AAA', fontWeight: 600, textTransform: 'none', '&:hover': { color: '#FFF', bgcolor: 'transparent' } }} 
                    disabled={loading}
                >
                    {cancelButtonText}
                </Button>
                <Button 
                    onClick={onConfirm} 
                    variant="contained"
                    sx={{ 
                        bgcolor: '#EF4444', 
                        color: '#FFF', 
                        fontWeight: 700, 
                        textTransform: 'none', 
                        px: 3,
                        borderRadius: '6px',
                        '&:hover': { bgcolor: '#DC2626' } 
                    }} 
                    autoFocus 
                    disabled={loading} 
                    startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
                >
                    {loading ? 'Please wait…' : confirmButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;